/*
 * @Author: czj
 * @Date: 2025-04-17 15:33:00
 * @Description: 优化后的 Axios 请求拦截器
 * @FilePath: \kp-rag-system\src\utils\request.js
 */
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken, getTicket } from '@/utils/auth'
import router from "@/router"

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 0 // 建议设置合理的超时时间（如30秒），0为永不超时
})

// ==================== 1. 请求拦截器 ====================
service.interceptors.request.use(
  config => {
    const token = getToken(), ticket = getTicket() // 获取 token 和 ticket
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['ticket'] = ticket; // 将 ticket 也添加到请求头中
    }
    return config
  },
  error => {
    console.error('[Request Error]:', error)
    return Promise.reject(error)
  }
)

// ==================== 2. 响应拦截器 ====================
service.interceptors.response.use(
  response => {
    const res = response.data
    const { code, message } = res

    // 放行正常状态码 (200, 201, 202, 10000)
    if (!code || [200, 201, 202, 10000].includes(Number(code))) {
      return res
    }

    // 处理业务错误码
    switch (Number(code)) {
      case 422:
        handle422ValidationError(message)
        break
      case 401:
        ElMessage.warning(message || 'License 认证已过期')
        break
      default:
        ElMessage.error(message || '系统响应异常')
    }

    return Promise.reject(new Error(message || 'Error'))
  },
  error => {
    // 过滤特定路由的报错
    if (window.location.hash === '#/index') {
      return Promise.reject(error)
    }

    let tipMsg = '网络错误'

    if (error.response) {
      const { status, data } = error.response
      const serverMessage = data?.message

      switch (status) {
        case 401:
          console.log('是否进入401错误');

          //登录过期 ，跳转登录页面
          router.push({ path: '/login' }) // 如果需要跳转可以打开
          tipMsg = serverMessage || '登录认证已过期，请刷新界面重新登录！！'
          break
        case 403:
          tipMsg = serverMessage || '拒绝访问'
          break
        case 404:
          tipMsg = '非法请求！！'
          router.push({ name: 'Dashboard' })
          break
        case 422:
          tipMsg = Array.isArray(serverMessage) ? serverMessage.join('；') : (serverMessage || '参数校验失败')
          break
        case 429:
          tipMsg = serverMessage || '请勿频繁操作，请在1分钟后尝试操作！！'
          break
        case 500:
          tipMsg = '服务器内部错误 (500)'
          // router.push({ name: 'Dashboard' }); // 如果需要跳转可以打开
          break
        default:
          tipMsg = serverMessage || `错误状态码: ${status}`
      }
    } else if (error.message) {
      // 处理超时或断网
      tipMsg = error.message.includes('timeout') ? '请求超时，请稍后重试' : error.message
    }

    ElMessage.error(tipMsg)
    return Promise.reject(error)
  }
)

/**
 * 提取 422 参数校验错误的通用处理逻辑
 */
function handle422ValidationError(message) {
  if (Array.isArray(message)) {
    // 修复原代码 join(',') 导致的逗号外露问题，并使用 dangerouslyUseHTMLString
    const htmlContent = `<div>${message.map(item => `<p style="margin: 4px 0;">${item}</p>`).join('')}</div>`
    ElMessage({
      type: 'error',
      message: htmlContent,
      dangerouslyUseHTMLString: true
    })
  } else {
    ElMessage.error(message || '参数校验失败')
  }
}

export default service